/* eslint-disable react/require-default-props */
import React, { useEffect, useRef } from 'react';
import { Select as ChakraSelect, Tooltip } from '@chakra-ui/react';
import { useField } from '@unform/core';

interface IOption {
  value: string;
  label: string;
}

interface SelectSimpleProps {
  name: string;
  options: IOption[];
  placeholder?: string;
  isDisabled?: boolean;
  // eslint-disable-next-line no-unused-vars
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

/**
 * Select padronizado (nativo, via Chakra) integrado ao Unform.
 * Segue o mesmo padrão do Global/Input (registra `path: 'value'` e usa
 * `defaultValue`), garantindo funcionamento em formulários de criação e edição.
 */
const SelectSimple: React.FC<SelectSimpleProps> = ({
  name,
  options,
  placeholder,
  isDisabled,
  onChange,
}) => {
  const selectRef = useRef<HTMLSelectElement>(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Tooltip hasArrow label={error} bg="#c53030">
      <ChakraSelect
        isInvalid={!!error}
        defaultValue={defaultValue}
        ref={selectRef}
        placeholder={placeholder || 'Selecione...'}
        size="md"
        color="gray.50"
        borderColor="gray.650"
        isDisabled={isDisabled}
        onChange={onChange}
      >
        {options.map(option => (
          <option
            key={option.value}
            value={option.value}
            style={{ color: '#000' }}
          >
            {option.label}
          </option>
        ))}
      </ChakraSelect>
    </Tooltip>
  );
};

export default SelectSimple;
